import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  showSignInCta: true,
  guards: {
    registered: { action: 'block' }
  }
} satisfies RecursivePartial<DialogConfig['signUp']>
